import styled from 'styled-components'
import theme from '../../../../styles/theme'
import { media } from '../../../../styles/utils'
import ButtonBase from '../../../../master/components/styled/ButtonBase'

const THUMBNAIL_SIZE_DESKTOP = '128px'
const THUMBNAIL_SIZE_MOBILE = '25%'

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  padding: 16px;
  border-top: ${theme.borderDefault};
  border-left: ${theme.borderDefault};
  border-right: ${theme.borderDefault};

  &:last-of-type {
    border-bottom: ${theme.borderDefault};
  }
`

export const ImageWrapper = styled.div`
  box-sizing: border-box;
  flex-grow: 0;
  max-width: ${THUMBNAIL_SIZE_DESKTOP};
  flex-basis: ${THUMBNAIL_SIZE_DESKTOP};
  height: 111px;
  padding-right: 17px;

  & > img {
    width: 100%;
  }

  ${media.sm`
    max-width: ${THUMBNAIL_SIZE_MOBILE};
    flex-basis: ${THUMBNAIL_SIZE_MOBILE};
  `};
`

export const ContentWrapper = styled.div`
  box-sizing: border-box;
  flex-grow: 0;
  max-width: calc(100% - ${THUMBNAIL_SIZE_DESKTOP});
  flex-basis: calc(100% - ${THUMBNAIL_SIZE_DESKTOP});
  margin-top: 0.35rem;

  ${media.sm`
    max-width: calc(100% - ${THUMBNAIL_SIZE_MOBILE});
    flex-basis: calc(100% - ${THUMBNAIL_SIZE_MOBILE});
  `};
`

export const Title = styled.h4`
  font-family: ${theme.brandFontFamily};
  font-size: ${theme.headingCheckout};
  font-weight: 400;
  margin: 0 0 1.75rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  ${media.sm`
    white-space: normal;
    overflow: auto;
  `};
`

export const DataWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  border: ${theme.borderDefault};
`

export const InputWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  padding: 0 17px;
`

export const Label = styled.span`
  font-weight: bold;
`

export const Button = styled(ButtonBase)`
  width: 48px;
  height: 48px;
  font-weight: 400;
  padding: 0;
  border: 1px solid transparent;
  border-left: ${theme.borderDefault};
  background-color: transparent;

  &:hover {
    background-color: ${theme.grayLight};
  }

  & > svg {
    margin: auto;
  }
`

export const AddButton = styled(ButtonBase)`
  max-width: 95px;
  font-weight: bold;
  border: 1px solid transparent;
  border-left: ${theme.borderDefault};
`
